const IconLogout = ({ className }) => {
    return (
        <svg viewBox='0 0 55 55' xmlns='http://www.w3.org/2000/svg' className={className}>
            <path
                d='M20.625 48.125H11.4583C10.2428 48.125 9.07697 47.6421 8.21743 46.7826C7.35789 45.923 6.875 44.7572 6.875 43.5417V11.4583C6.875 10.2428 7.35789 9.07697 8.21743 8.21743C9.07697 7.35789 10.2428 6.875 11.4583 6.875H20.625M36.6667 38.9583L48.125 27.5M48.125 27.5L36.6667 16.0417M48.125 27.5L20.625 27.5'
                strokeWidth='4.58333'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};

export default IconLogout;
